export const environment = {
  name: 'STAGING',
  production: false,
  mailUrl: 'https://formsubmit.co/e31a55f737a18f729e43e56af5fa50ad',
  baseUrl: 'https://stage.vishwasfotography.com',
  ccEmail: ''
};